<template>
    <nav class="mb-5 mb-md-5 mb-lg-3">
        <slot/>
    </nav>
</template>
